import React from "react";
import StudentProvider from "./Provider/StudentProvider/StudentProvider";
import CategoryMasterProvider from "./Provider/CategoryMasterProvider/CategoryMasterProvider";
import SubCategoryMasterProvider from "./Provider/SubCategoryMasterProvider/SubCategoryMasterProvider";
import SubjectMasterProvider from "./Provider/SubjectMasterProvider/SubjectMasterProvider";
import TopicMasterProvider from "./Provider/TopicMasterProvider/TopicMasterProvider";
import QuestionBankProvider from "./Provider/QuestionBankProvider/QuestionBankProvider";
import PearlsProvider from "./Provider/PearlsProvider/PearlsProvider";
import PlansProvider from "./Provider/PlansProvider/PlansProvider";
import CouponsProvider from "./Provider/CouponsProvider/CouponsProvider";
import QuestionMasterProvider from "./Provider/QuestionMasterProvider/QuestionMasterProvider";
import ExamsProvider from "./Provider/ExamsProvider/ExamsProvider";
import TestSeriesProvider from "./Provider/TestSeries/TestSeriesProvider";
import VideoProvider from "./Provider/VideoProvider/VideoProvider";
import UpdatesProvider from './Provider/UpdatesProvider/UpdatesProvider';
import VideoOrderProvider from './Provider/VideoOrderProvider/VideoOrderProvider';
import ExamOrderContext from "./Provider/ExamOrderProvider/ExamOrderProvider";
import PearlsOrderProvider from "./Provider/PearlsOrderProvider/PearlsOrderProvider";
import UpdatesOrderProvider from "./Provider/UpdatesOrderProvider/UpdatesOrderProvider";
import ImagesProvider from "./Provider/ImagesProvider/ImagesProvider";
import OfflineProvider from "./Provider/OfflineProvider/OfflineProvider";
import TPCouponProvider from "./Provider/TPCouponProvider/TPCouponProvider";
import FeedBackProvider from "./Provider/FeedBackProvider/FeedBackProvider";
import NotificationProvider from "./Provider/NotificationProvider/NotificationProvider";
import DashboardProvider from "./Provider/DashboardProvider/DashboardProvider";
import DNBMDProvider from "./Provider/DNBMDProvider/DNBMDProvider";
import AccessSettingsProvider from "./Provider/AccessSettingsProvider/AccessSettingsProvider";
import StaffProvider from "./Provider/StaffProvider/StaffProvider";
import AutomationProvider from "./Provider/AutomationProvider/AutomationProvider";
import DuplicateContentProvider from "./Provider/DuplicateContentProvider/DuplicateContentProvider";
import DNBMDOrderProvider from "./Provider/DNBMDOrderProvider/DNBMDOrderProvider";
import VideoV2Provider from "./Provider/VideoV2Provider/VideoV2Provider";
import QbankV2Provider from "./Provider/QbankV2Provider/QbankV2Provider";
import PearlsV2Provider from "./Provider/PearlsV2Provider/PearlsV2Provider";
import UpdatesV2Provider from "./Provider/UpdatesV2Provider/UpdatesV2Provider";
import DNBMDV2Provider from "./Provider/DNBMDV2Provider/DNBMDV2Provider";
import Routes from "./Routes";

const App = () => {
  return (
    <React.Fragment>
      <DNBMDOrderProvider>
        <QbankV2Provider>
        <VideoV2Provider>
          <PearlsV2Provider>
            <UpdatesV2Provider>
              <DNBMDV2Provider>
          <DuplicateContentProvider>
            <AutomationProvider>
              <StaffProvider>
                <AccessSettingsProvider>
                  <DNBMDProvider>
                    <DashboardProvider>
                      <NotificationProvider>
                        <FeedBackProvider>
                          <TPCouponProvider>
                            <OfflineProvider>
                              <ImagesProvider>
                                <UpdatesOrderProvider>
                                  <PearlsOrderProvider>
                                    <ExamOrderContext>
                                      <VideoOrderProvider>
                                        <VideoProvider>
                                          <UpdatesProvider>
                                            <TestSeriesProvider>
                                              <ExamsProvider>
                                                <QuestionMasterProvider>
                                                  <CouponsProvider>
                                                    <PlansProvider>
                                                      <PearlsProvider>
                                                        <CategoryMasterProvider>
                                                          <SubCategoryMasterProvider>
                                                            <SubjectMasterProvider>
                                                              <TopicMasterProvider>
                                                                <QuestionBankProvider>
                                                                  <StudentProvider>
                                                                    <Routes />
                                                                  </StudentProvider>
                                                                </QuestionBankProvider>
                                                              </TopicMasterProvider>
                                                            </SubjectMasterProvider>
                                                          </SubCategoryMasterProvider>
                                                        </CategoryMasterProvider>
                                                      </PearlsProvider>
                                                    </PlansProvider>
                                                  </CouponsProvider>
                                                </QuestionMasterProvider>
                                              </ExamsProvider>
                                            </TestSeriesProvider>
                                          </UpdatesProvider>
                                        </VideoProvider>
                                      </VideoOrderProvider>
                                    </ExamOrderContext>
                                  </PearlsOrderProvider>
                                </UpdatesOrderProvider>
                              </ImagesProvider>
                            </OfflineProvider>
                          </TPCouponProvider>
                        </FeedBackProvider>
                      </NotificationProvider>
                    </DashboardProvider>
                  </DNBMDProvider>
                </AccessSettingsProvider>
              </StaffProvider>
            </AutomationProvider>
          </DuplicateContentProvider>
          </DNBMDV2Provider>
          </UpdatesV2Provider>
          </PearlsV2Provider>
        </VideoV2Provider>
        </QbankV2Provider>
      </DNBMDOrderProvider>
    </React.Fragment>
    
  );
};

export default App;
